module.exports = __webpack_public_path__ + "img/体育公益_1@2x.a2aef05a.png";